export default "__VITE_ASSET__9f546dc8__"